document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  const toggle = document.getElementById('mobile-menu-toggle');
  const nav = document.getElementById('main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('active');
      this.classList.toggle('active');
    });
  }

  // Mobile: tap dropdown toggles (not hover)
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.nav-item--dropdown > .nav-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        this.closest('.nav-item--dropdown').classList.toggle('mobile-open');
      });
    });
    document.querySelectorAll('.dropdown-item--has-sub > a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        this.closest('.dropdown-item--has-sub').classList.toggle('mobile-open');
      });
    });
  }

  // Sticky header shadow
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 24px rgba(0,75,73,0.5)'
        : '0 2px 12px rgba(0,75,73,0.4)';
    }, { passive: true });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Close mobile menu on outside click
  document.addEventListener('click', function(e) {
    if (nav && nav.classList.contains('active') && !nav.contains(e.target) && !toggle.contains(e.target)) {
      nav.classList.remove('active');
    }
  });
});
